import { $customerAuth } from '@/lib/auth';
import { useStore } from '@nanostores/react';
import { redirectPage } from '@nanostores/router';
import { lazy, Suspense, useEffect, useMemo } from 'react';
import './index.css';
import { $router } from './router';

const ArticleView = lazy(() => import('./components/ArticleView'));
const ChatView = lazy(() => import('./components/ChatView'));
const Login = lazy(() => import('./components/Login'));

function LoadingFallback() {
  return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
}

function App() {
  const page = useStore($router);
  const customerAuth = useStore($customerAuth);
  const customer = page ? (page.params as { customer: string }).customer : '';
  const hasAuth = !!customerAuth[customer]?.accessToken;
  const isRoot = useMemo(() => !page || page.route === 'root' || !page.params.customer, [page]);

  useEffect(() => {
    if (isRoot) {
      return;
    }
    if (!hasAuth) {
      let route: 'login' | 'register' = 'login';
      if (page?.route === 'register') {
        route = 'register';
      }
      redirectPage($router, route, { customer });
    } else if (page?.route === 'login' || page?.route === 'register') {
      redirectPage($router, 'customer', { customer });
    }
  }, [customer, hasAuth, isRoot, page?.route]);

  if (isRoot) {
    return (
      <p>
        no customer in url |{' '}
        <a className="text-indigo-600" href="/chat/12042269">
          ho
        </a>{' '}
        |{' '}
        <a className="text-indigo-600" href="/chat/b64b22bd">
          onecloudonly
        </a>{' '}
        |{' '}
        <a className="text-indigo-600" href="/chat/e8d6ebcc">
          stagingsinsheim
        </a>
      </p>
    );
  }

  if (page?.route === 'register') {
    return (
      <Suspense fallback={<LoadingFallback />}>
        <Login customer={customer} register />
      </Suspense>
    );
  }

  if (page?.route === 'login') {
    return (
      <Suspense fallback={<LoadingFallback />}>
        <Login customer={customer} />
      </Suspense>
    );
  }

  return (
    <>
      <Suspense fallback={<LoadingFallback />}>
        <ChatView customer={customer} />
      </Suspense>
      {page?.route === 'article' && (
        <Suspense fallback={<LoadingFallback />}>
          <ArticleView />
        </Suspense>
      )}
    </>
  );
}

export default App;
